module.exports = __webpack_public_path__ + "fonts/poppins-bold-webfont.3bdb1809.woff";